import * as React from "react";
// Import interfaces
import {
  Mode,
  Grid as IGrid,
  HoursInDayDiffTime,
  GridCell,
} from "../helpers/interfaces";
// Import types
import {
  BaseTimeFormat,
  ChannelWithPosition,
  Position,
} from "../helpers/types";
// Import hooks
import { useGrid } from "../hooks";
import { GridCellItem } from "./GridCellItem";
// Import styles
import { GridStyled } from "../styles";

const { GridContainer } = GridStyled;

interface GridProps {
  isVerticalMode: boolean;
  isProgramVisible: (position: Position, overlapsCount: number) => boolean;
  isBaseTimeFormat: BaseTimeFormat;
  channelOverlapsCount: Record<string, number>;
  hourWidth: number;
  dayWidth: number;
  days: string[];
  hoursInDays: HoursInDayDiffTime[];
  months: string[];
  numberOfDays: number;
  numberOfHoursInDay: number;
  numberOfMonths: number;
  offsetStartHoursRange: number;
  gridItems: { position: Position; channel: ChannelWithPosition }[];
  grid: IGrid;
  mode: Mode;
  sidebarWidth: number;
  timelineHeight: number;
  timelineDividers: number;
  renderGridCell?: (props: GridCell) => React.ReactNode;
}

export function Grid({
  isVerticalMode,
  isProgramVisible,
  channelOverlapsCount,
  grid,
  gridItems,
  mode,
  hourWidth,
  timelineDividers,
  renderGridCell,
  ...rest
}: GridProps) {
  const { onItemClick, onItemDrop } = useGrid({
    isVerticalMode,
    grid,
    mode,
    hourWidth,
    timelineDividers,
    ...rest,
  });

  const isDayMode = mode.type === "day";
  const isHoverHighlight = grid.hoverHighlight;
  const isItemClickable = !!grid.onGridItemClick;

  const renderGridItem = (
    item: { position: Position; channel: ChannelWithPosition },
    index: number
  ) => {
    const props = {
      isVerticalMode,
      isProgramVisible,
      isHoverHighlight,
      isDayMode,
      isItemClickable,
      item,
      index,
      channelOverlapsCount,
      hourWidth,
      timelineDividers,
      renderGridCell,
      onItemClick,
      onItemDrop,
    };

    // @ts-ignore
    return <GridCellItem key={item.channel.uuid + index} {...props} />;
  };

  return (
    <GridContainer className="planby-grid">
      {gridItems.map((item, index) => renderGridItem(item, index))}
    </GridContainer>
  );
}
